const EXPECTED_CPT_EVENTS = [
  'cardiac',
  'hemorrhage',
  'infection',
  'morbidity',
  'mortality',
  'neurological',
  'pulmonary',
  'readmission',
  'renal',
  'urinary',
  'venous',
  'needsICU',
  'notHome'
];

function isPropMissingOrNull(target, prop) {
  return !Object.prototype.hasOwnProperty.call(target, prop) || target[prop] === null;
}

function validate(raw, callback) {
  let cptEvent;
  let i;
  let missingCptEventRate;
  const output = {};

  const useCallback = typeof callback === 'function';

  function throwError(target, message) {
    const err = new TypeError(message);

    err.target = target;

    if (useCallback) {
      return callback(err);
    }

    throw err;
  }

  if (isPropMissingOrNull(raw, 'procedureFrequency')) {
    return throwError('procedureFrequency', 'Missing required parameter');
  }

  output.procedureFrequency = parseInt(raw.procedureFrequency, 10);
  output.hemorrhageFrequency = raw.hemorrhageFrequency;
  output.readmissionFrequency = raw.readmissionFrequency;
  output.notHomeFrequency = raw.notHomeFrequency;
  output.isInfrequentProcedure = output.procedureFrequency < 100;

  if (isPropMissingOrNull(raw, 'cptCode')) {
    return throwError('cptCode', 'Missing required parameter');
  }

  output.cptCode = String(raw.cptCode);

  if (isPropMissingOrNull(raw, 'isEmergency')) {
    return throwError('isEmergency', 'Missing required parameter');
  }

  output.isEmergency = Boolean(raw.isEmergency);

  if (isPropMissingOrNull(raw, 'isInpatient')) {
    return throwError('isInpatient', 'Missing required parameter');
  }

  output.isInpatient = Boolean(raw.isInpatient);

  if (isPropMissingOrNull(raw, 'needsICUBed')) {
    return throwError('needsICUBed', 'Missing required parameter');
  }

  output.needsICUBed = Boolean(raw.needsICUBed);

  if (isPropMissingOrNull(raw, 'patientAge')) {
    return throwError('patientAge', 'Missing required parameter');
  }

  output.patientAge = parseFloat(raw.patientAge);

  if (output.patientAge < 18) {
    return throwError('patientAge', 'Parameter out of range; age too low (18 or older)');
  }

  if (isPropMissingOrNull(raw, 'patientHealthStatus')) {
    return throwError('patientHealthStatus', 'Missing required parameter');
  }

  if (raw.patientHealthStatus < 0 || raw.patientHealthStatus > 2) {
    return throwError('patientHealthStatus', 'Parameter out of range (0 - 2)');
  }

  output.patientHealthStatus = parseInt(raw.patientHealthStatus, 10);

  if (isPropMissingOrNull(raw, 'patientPhysicalStatus')) {
    return throwError('patientPhysicalStatus', 'Missing required parameter');
  }

  if (raw.patientPhysicalStatus < 1 || raw.patientPhysicalStatus > 5) {
    return throwError('patientPhysicalStatus', 'Parameter out of range (1 - 5)');
  }

  output.patientPhysicalStatus = parseInt(raw.patientPhysicalStatus, 10);

  if (isPropMissingOrNull(raw, 'tier')) {
    return throwError('tier', 'Missing required parameter');
  }

  if (raw.tier < 0 || raw.tier > 4) {
    return throwError('tier', 'Parameter out of range (0 - 3)');
  }

  output.tier = parseInt(raw.tier, 10);

  if (!output.isInfrequentProcedure && isPropMissingOrNull(raw, 'procedureEventRate')) {
    return throwError('procedureEventRate', 'Missing required parameter');
  }

  if (!output.isInfrequentProcedure && typeof raw.procedureEventRate !== 'object') {
    return throwError('procedureEventRate', 'Invalid type (must be an Object)');
  }

  output.procedureEventRate = {};

  if (!output.isInfrequentProcedure) {
    for (i = 0; i < EXPECTED_CPT_EVENTS.length; i++) {
      cptEvent = EXPECTED_CPT_EVENTS[i];

      if (!Object.prototype.hasOwnProperty.call(raw.procedureEventRate, cptEvent)) {
        missingCptEventRate = cptEvent;
        break;
      }

      if (raw.procedureEventRate[cptEvent] === null) {
        output.procedureEventRate[cptEvent] = null;
      } else {
        output.procedureEventRate[cptEvent] = parseFloat(raw.procedureEventRate[cptEvent]);
      }
    }
  }

  if (missingCptEventRate) {
    return throwError(`procedureEventRate.${missingCptEventRate}`, 'Missing required parameter');
  }

  if (isPropMissingOrNull(raw, 'procedureRelativeValueUnits')) {
    output.procedureRelativeValueUnits = null;
  } else {
    output.procedureRelativeValueUnits = parseFloat(raw.procedureRelativeValueUnits);
  }

  if (isPropMissingOrNull(raw, 'practitionerSpecialty')) {
    return throwError('practitionerSpecialty', 'Missing required parameter');
  }

  if (raw.practitionerSpecialty < 0 || raw.practitionerSpecialty > 9) {
    return throwError('practitionerSpecialty', 'Parameter out of range (0 - 9)');
  }

  output.practitionerSpecialty = parseInt(raw.practitionerSpecialty, 10);

  if (useCallback) {
    return callback(null, output);
  }

  return output;
}

export default validate;
